import clsx from 'clsx';
import { ConnectedEventInfo } from 'src/components/Events/ConnectedEventInfo';
import { Stack } from 'src/core/ui';

import * as styles from './OnSaleEventCatchUp.css';
import { OnSaleEventCatchUpCardProps } from './OnSaleEventCatchUpCard.types';

export function OnSaleEventCatchUpCard({
  event: onSaleEvent,
  showYear,
  onClick,
  isActive,
  isMarked,
  onMarkEvent,
}: OnSaleEventCatchUpCardProps) {
  const { event, venue, performer } = onSaleEvent;

  return (
    <Stack
      className={clsx(styles.onSaleEventCatchUpCard, {
        [styles.onSaleEventCatchUpCardActive]: isActive && !isMarked,
        [styles.onSaleEventCatchUpCardMarked]: isMarked,
      })}
      direction="row"
      gap="s"
      width="full"
      onClick={onClick}
    >
      <div style={{ flex: '1 1 auto', minWidth: 0 }}>
        <ConnectedEventInfo
          showYear={showYear}
          event={event}
          performer={performer}
          venue={venue}
          useShortName
          showEventDateTbd
          slimMode
          linkEvent={false}
          eventDateClassName={styles.eventCardVenueAndDateText}
          venueClassName={styles.eventCardVenueAndDateText}
        />
      </div>
      {/* <div className={styles.onSaleEventCatchUpCardMark}>
        <Stack
          alignItems="center"
          justifyContent="center"
          className={clsx(styles.onSaleEventCatchUpCardMarkIcon, {
            [styles.onSaleEventCatchUpCardMarkIconActive]: isMarked,
          })}
        >
          <BookmarkIcon onClick={isMarked ? undefined : onMarkEvent} />
        </Stack>
      </div> */}
    </Stack>
  );
}
